module.exports = __webpack_public_path__ + "img/icon-favorito.4e9b1803.svg";